import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  class: "common-layout",
  style: {"padding-right":"0"}
}
const _hoisted_2 = { class: "console-wrapper" }
const _hoisted_3 = { class: "stat-cards" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "我的余额", -1)
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-actions" }
const _hoisted_8 = { class: "cards-row" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "用户信息管理")
], -1)
const _hoisted_11 = { class: "card-body user-form" }
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "用户编号", -1)
const _hoisted_14 = { class: "field-input disabled" }
const _hoisted_15 = { class: "form-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "用户名", -1)
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "我的上级", -1)
const _hoisted_19 = { class: "field-input disabled" }
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "绑定邮箱", -1)
const _hoisted_22 = { class: "field-input disabled" }
const _hoisted_23 = { class: "form-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "登录密码", -1)
const _hoisted_25 = { class: "form-actions-row" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "收款信息管理")
], -1)
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "upload-grid" }
const _hoisted_30 = { class: "upload-item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "upload-label" }, "微信", -1)
const _hoisted_32 = { class: "upload-item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "upload-label" }, "支付宝", -1)
const _hoisted_34 = { class: "table-wrapper" }
const _hoisted_35 = { class: "table-section" }
const _hoisted_36 = { class: "table-header" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "授权列表", -1)
const _hoisted_38 = { class: "table-scroll" }
const _hoisted_39 = { class: "data-table" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "插件名"),
    /*#__PURE__*/_createElementVNode("th", null, "插件版本"),
    /*#__PURE__*/_createElementVNode("th", null, "插件id"),
    /*#__PURE__*/_createElementVNode("th", null, "添加时间"),
    /*#__PURE__*/_createElementVNode("th", null, "授权字段"),
    /*#__PURE__*/_createElementVNode("th", null, "授权者id"),
    /*#__PURE__*/_createElementVNode("th", null, "到期时间"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_41 = ["onUpdate:modelValue", "onChange"]
const _hoisted_42 = { class: "action-btns" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "table-footer" }
const _hoisted_46 = { class: "dialog-footer" }
const _hoisted_47 = { class: "dialog-footer" }
const _hoisted_48 = { class: "empower-form" }
const _hoisted_49 = { class: "empower-field" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "授权插件", -1)
const _hoisted_51 = { class: "empower-field" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "功能版本", -1)
const _hoisted_53 = { class: "empower-field" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "授权时长单位", -1)
const _hoisted_55 = { class: "empower-field" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "授权时长", -1)
const _hoisted_57 = { class: "number-input-group" }
const _hoisted_58 = {
  key: 0,
  class: "unit-text"
}
const _hoisted_59 = { class: "empower-field" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "绑定邮箱", -1)
const _hoisted_61 = { class: "empower-field" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "empower-label" }, "授权字段(域名/ip等)", -1)
const _hoisted_63 = {
  key: 0,
  class: "empower-total"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "总计:", -1)
const _hoisted_65 = { class: "total-price" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "total-unit" }, "元", -1)
const _hoisted_67 = { class: "dialog-footer empower-footer" }
const _hoisted_68 = { style: {"padding":"1rem 0"} }
const _hoisted_69 = { style: {"margin-bottom":"1rem"} }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.875rem","color":"#374151"} }, "充值金额", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.875rem","color":"#374151"} }, "支付方式", -1)
const _hoisted_72 = { class: "dialog-footer" }

import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage, } from 'element-plus'
import type { UploadProps } from 'element-plus'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { Platform } from '@element-plus/icons-vue/dist/types';
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsoleView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const updateHostClick = (empower_id: number, update_host: string) => {
  updateHost_data.value.empower_id = empower_id
  updateHost_data.value.update_host = update_host
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}
const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  // const data = new FormData()
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  // data.append("empower_id", appConf.value.empower_id+"")
  // data.append("time_act", time_meal_data.value.meal_id + "")
  // data.append("time_num", time_meal_data.value.num + "")
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        ElMessage.success(res.data.msg)
        await getUserInfo();
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        if (res.data.total_empower < empower_Conf.value.pageSize) {
          empower_Conf.value.disabled = true
        }
      }
      else {
        ElMessage.error(res.data.msg)
        if (res.data.code == 401) {
          ElMessage.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      if (!user_conf.value.username) {
        fullscreenLoading.close()
        ElMessage.error('请输入用户名')
        return
      }
      data.append("act", "setUserInfo");
      if (user_conf.value.password) {
        data.append("password", user_conf.value.password);
      }
      if (user_conf.value.username) {
        data.append("username", user_conf.value.username);
      }
      if (user_conf.value.user_email) {
        data.append("user_email", user_conf.value.user_email);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case "updateHost":
      data.append("act", "updateHost");
      if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
        data.append("empower_id", String(updateHost_data.value.empower_id));
      }
      if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
        data.append("update_host", updateHost_data.value.update_host);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    ElMessage.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const url = res.data.data.url;
        if (!isNull(url)) {
          window.open(res.data.data.url, '_blank');
        } else {
          const outTradeNo = res.data.data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        }
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
  ElMessage.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg",
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    ElMessage.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    ElMessage.success(response.msg)
    if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    }
    else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    ElMessage.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const getEmpower1 = async () => {
  const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
  if (res.code == 200) {
    empower_Conf.value.total = res.total_empower
    if (res.data.total_empower < empower_Conf.value.pageSize) {
      empower_Conf.value.disabled = true
    }
    empower_data.value = res.data
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          ElMessage.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        ElMessage.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        ElMessage.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        ElMessage.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100vh","width":"100vw"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"fit-content"} }, {
          default: _withCtx(() => [
            _createVNode(UserHead)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(HeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { style: {"padding":"0","overflow":"auto","background-color":"#fff !important"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(user_conf).money) + "元", 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", {
                          class: "stat-btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (puy_money()))
                        }, "在线充值"),
                        _createElementVNode("span", {
                          class: "stat-btn",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (withdrawalView()))
                        }, "提现")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(user_conf).uid), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user_conf).username) = $event)),
                            placeholder: "请输入用户名"
                          }, null, 512), [
                            [_vModelText, _unref(user_conf).username]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(user_conf).higher_uid), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(user_conf).user_email), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input",
                            type: "password",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user_conf).password) = $event)),
                            placeholder: "***********"
                          }, null, 512), [
                            [_vModelText, _unref(user_conf).password]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("button", {
                            class: "btn-save",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')))
                          }, " 保存修改 ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _hoisted_31,
                            (!_unref(isNull)(_unref(user_conf).wxQR_code))
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  "preview-src-list": [_unref(user_conf).wxQR_code],
                                  src: _unref(user_conf).wxQR_code,
                                  "zoom-rate": 1.2,
                                  "max-scale": 7,
                                  "min-scale": 0.2,
                                  fit: "cover",
                                  class: "upload-preview"
                                }, null, 8, ["preview-src-list", "src"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_upload, {
                              "show-file-list": false,
                              class: "upload-btn",
                              action: upload.value.url,
                              data: upload.value.wx_data,
                              limit: 1,
                              "on-exceed": handleExceed,
                              "on-success": handleSuccess,
                              "before-upload": beforeAvatarUpload
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["action", "data"])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            (!_unref(isNull)(_unref(user_conf).zfbQR_code))
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  "preview-src-list": [_unref(user_conf).zfbQR_code],
                                  src: _unref(user_conf).zfbQR_code,
                                  "zoom-rate": 1.2,
                                  "max-scale": 7,
                                  "min-scale": 0.2,
                                  fit: "cover",
                                  class: "upload-preview"
                                }, null, 8, ["preview-src-list", "src"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_upload, {
                              "show-file-list": false,
                              class: "upload-btn",
                              action: upload.value.url,
                              data: upload.value.zfb_data,
                              limit: 1,
                              "on-exceed": handleExceed,
                              "on-success": handleSuccess,
                              "before-upload": beforeAvatarUpload
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["action", "data"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("button", {
                          class: "add-btn",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (addEmpowerFun('dialog')))
                        }, "添加授权")
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("table", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(empower_data), (row) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row.empower_id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(row.includes_name), 1),
                                _createElementVNode("td", null, _toDisplayString(row.version_name), 1),
                                _createElementVNode("td", null, _toDisplayString(row.includes_id), 1),
                                _createElementVNode("td", null, _toDisplayString(row.add_date), 1),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "host-input",
                                    "onUpdate:modelValue": ($event: any) => ((row.empower_host) = $event),
                                    onChange: ($event: any) => (updateHostClick(row.empower_id, row.empower_host)),
                                    placeholder: "请输入"
                                  }, null, 40, _hoisted_41), [
                                    [_vModelText, row.empower_host]
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(row.add_uid), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["status-badge", {
                            'status-active': getEndDateColor(row.end_date) == 1,
                            'status-warning': getEndDateColor(row.end_date) == 2,
                            'status-danger': getEndDateColor(row.end_date) == 3
                          }])
                                  }, _toDisplayString(row.end_date), 3)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_42, [
                                    (getEndDateColor(row.end_date) === 3 || row.is_free == 1)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "action-btn btn-delete",
                                          onClick: ($event: any) => (deleteAuthDialog(row.empower_id))
                                        }, "删除", 8, _hoisted_43))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      class: "action-btn btn-renew",
                                      onClick: ($event: any) => (renewAuthDialog(row.empower_id, row.includes_id, row.version))
                                    }, "续费", 8, _hoisted_44)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_el_pagination, {
                          "current-page": empower_Conf.value.currentPage,
                          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((empower_Conf.value.currentPage) = $event)),
                          "page-size": empower_Conf.value.pageSize,
                          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((empower_Conf.value.pageSize) = $event)),
                          "page-sizes": [10, 25, 50],
                          disabled: empower_Conf.value.disabled,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: empower_Conf.value.total,
                          onSizeChange: sizeChange,
                          onCurrentChange: currentChange
                        }, null, 8, ["current-page", "page-size", "disabled", "total"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(centerDialog).isShow,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(centerDialog).isShow) = $event)),
                    title: _unref(centerDialog).title,
                    width: "500",
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(centerDialog).isShow = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (centerDialogClick(_unref(centerDialog).clickBind)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确认 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(centerDialog).content), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "title"]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(trendsDialog).dialogVisible,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(trendsDialog).dialogVisible) = $event)),
                    title: "选择等级",
                    style: {"width":"fit-content"},
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(trendsDialog).dialogVisible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (centerDialogClick('gradeUp')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确认升级 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        "label-position": "top",
                        style: {"width":"40rem"},
                        "label-width": "auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "升级等级" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: select_option.value,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((select_option).value = $event)),
                                placeholder: "请选择需要升级的等级"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grade_Option), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.grade_id,
                                      label: item.name + '---' + item.price_diff + '元',
                                      value: item.grade_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128)),
                                  (_unref(grade_Option).length == 0)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: "您已经是最高等级了"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(addEmpower_dialog).dialogVisible,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addEmpower_dialog).dialogVisible) = $event)),
                    title: "添加授权",
                    "align-center": "",
                    class: "add-empower-dialog"
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("button", {
                          class: "btn-cancel",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(addEmpower_dialog).dialogVisible = false))
                        }, "关闭"),
                        _withDirectives(_createElementVNode("button", {
                          class: "btn-primary",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice.value + '元', true, 'addEmpower')))
                        }, " 添加授权 ", 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        _withDirectives(_createElementVNode("button", {
                          class: "btn-primary",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice.value + '元', true, 'renewEmpower')))
                        }, " 续费授权 ", 512), [
                          [_vShow, _unref(appConf).isRenew]
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_48, [
                        _withDirectives(_createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _createVNode(_component_el_select, {
                            modelValue: _unref(includes_data).select_option,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(includes_data).select_option) = $event)),
                            onChange: getPluginVersions,
                            placeholder: "请选择插件"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(includes_data).includes_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.id + '---' + item.platform + '---' + item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128)),
                              (_unref(includes_data).includes_list.length == 0)
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 0,
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("--暂无插件/您不是任何插件的代理--")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ], 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createVNode(_component_el_select, {
                            modelValue: _unref(version_data).select_option,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(version_data).select_option) = $event)),
                            onChange: onVersionChange,
                            placeholder: "请选择功能版本",
                            disabled: _unref(version_data).version_list.length === 0
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(version_data).version_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.version,
                                  label: item.version + '--' + item.versionName,
                                  value: item.version
                                }, null, 8, ["label", "value"]))
                              }), 128)),
                              (_unref(version_data).version_list.length === 0 && _unref(includes_data).select_option)
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 0,
                                    disabled: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("--该插件无版本信息--")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ], 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createVNode(_component_el_select, {
                            modelValue: _unref(time_meal_data).select_option,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(time_meal_data).select_option) = $event)),
                            onChange: _cache[18] || (_cache[18] = ($event: any) => (setTimeMeal(_unref(time_meal_data).select_option))),
                            placeholder: "请选择时长单位",
                            disabled: _unref(time_meal_data).time_meal_list.length === 0
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_meal_data).time_meal_list, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.meal_id,
                                  label: item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元',
                                  value: item.meal_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_el_input_number, {
                              modelValue: _unref(time_meal_data).num,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(time_meal_data).num) = $event)),
                              min: _unref(time_meal_data).min,
                              max: _unref(time_meal_data).max
                            }, null, 8, ["modelValue", "min", "max"]),
                            (_unref(time_meal_data).unit != '')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_unref(time_meal_data).unit), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _withDirectives(_createElementVNode("input", {
                            class: "empower-input",
                            type: "text",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addEmpower_dialog).user_email) = $event)),
                            placeholder: "若是普通用户则填写当前绑定邮箱"
                          }, null, 512), [
                            [_vModelText, _unref(addEmpower_dialog).user_email]
                          ])
                        ], 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _withDirectives(_createElementVNode("input", {
                            class: "empower-input",
                            type: "text",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(addEmpower_dialog).host) = $event)),
                            placeholder: "请输入域名或IP"
                          }, null, 512), [
                            [_vModelText, _unref(addEmpower_dialog).host]
                          ])
                        ], 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        (_unref(time_meal_data).unit != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                              _hoisted_64,
                              _createElementVNode("span", _hoisted_65, _toDisplayString(getTimePrice.value), 1),
                              _hoisted_66
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _unref(balanceRechargeDialog).isShow,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(balanceRechargeDialog).isShow) = $event)),
                    title: "充值",
                    width: "500",
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_unref(balanceRechargeDialog).isShow = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (toRecharge()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确定 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createVNode(_component_el_input, {
                            min: _unref(balanceRechargeDialog).checkType.min,
                            max: _unref(balanceRechargeDialog).checkType.max,
                            modelValue: _unref(balanceRechargeDialog).money,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(balanceRechargeDialog).money) = $event)),
                            style: {"width":"80%","margin-left":"1rem"},
                            size: "large",
                            placeholder: '单笔充值范围:' + _unref(balanceRechargeDialog).checkType.min + '--' + _unref(balanceRechargeDialog).checkType.max,
                            type: "number"
                          }, null, 8, ["min", "max", "modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_71,
                          _createVNode(_component_el_select, {
                            modelValue: _unref(balanceRechargeDialog).type,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(balanceRechargeDialog).type) = $event)),
                            placeholder: "支付方式",
                            size: "large",
                            style: {"width":"80%","margin-left":"1rem"},
                            onChange: payTypeChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(balanceRechargeDialog).types, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.type,
                                  label: item.name + '(手续费' + item.fee + ')',
                                  value: item.type
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})